import { Input } from 'antd'
import React from 'react'

const AeroInput = props => {
	return <Input size={props.size ? props.size : 'large'} style={{ borderRadius: '6px', ...props.otherstyles }} {...props} />
}

export default AeroInput
